








import {Component, Prop, Vue} from "vue-property-decorator"
import gravatar from "gravatar"
import {User} from "@/interface"

@Component({})
export default class Gravatar extends Vue {

  @Prop({type: Object, required: true}) private user!: User
  @Prop({type: String, default: "middle"}) private size_class!: string

  get src() {
    return this.user ? gravatar.url(this.user.email) : null
  }

}
